import { Redacted, Schema } from "effect";
import { privateDependencyFailure } from "@workerstation/shared/errors/private-cause";
import type { ReviewDeepLinkParseResult } from "@workerstation/shared/review-deep-link";

export const ReviewNavigationMode = Schema.Literals(["push", "replace"]);
export type ReviewNavigationMode = typeof ReviewNavigationMode.Type;
export class ReviewNavigationFailure extends privateDependencyFailure<ReviewNavigationFailure>()("ReviewNavigationFailure", "review-navigation") {}
export const reviewNavigationFailure = (cause: unknown) => new ReviewNavigationFailure({ cause: Redacted.make(cause) });
export type ReviewNavigationListener = (result: ReviewDeepLinkParseResult) => void;
